'use client';

import Link from 'next/link';
import Image from 'next/image';
import { Mail, MapPin, Linkedin } from 'lucide-react';
import { getConsumerUrl } from '@/lib/urls';
import { DynamicLink } from './DynamicLink';

export function ProfessionalFooter() {
  return (
    <footer className="bg-ink text-white">
      <div className="container-site section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <Image
                src="/images/logo.svg"
                alt="ValBewust"
                width={200}
                height={45}
                className="h-10 w-auto brightness-0 invert"
              />
              <span className="text-xs text-white font-semibold bg-white/20 px-2 py-1 rounded">Zakelijk</span>
            </div>
            <p className="text-white/70 mb-6">
              Valpreventie pakketten voor gemeenten, zorgverzekeraars en zorginstellingen.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <p className="font-semibold text-lg mb-4">Professionals</p>
            <ul className="space-y-3">
              <li>
                <Link href="/voor-wie" className="text-white/70 hover:text-white transition-colors">
                  Voor Wie
                </Link>
              </li>
              <li>
                <Link href="/pakketten" className="text-white/70 hover:text-white transition-colors">
                  Pakketten & Prijzen
                </Link>
              </li>
              <li>
                <Link href="/platform" className="text-white/70 hover:text-white transition-colors">
                  Platform
                </Link>
              </li>
              <li>
                <Link href="/faq" className="text-white/70 hover:text-white transition-colors">
                  Veelgestelde Vragen
                </Link>
              </li>
              <li>
                <Link href="/blog" className="text-white/70 hover:text-white transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Consumer Link */}
          <div>
            <p className="font-semibold text-lg mb-4">Voor Consumenten</p>
            <ul className="space-y-3">
              <li>
                <DynamicLink getHref={() => getConsumerUrl()} className="text-white/70 hover:text-white transition-colors">
                  Naar de App
                </DynamicLink>
              </li>
              <li>
                <DynamicLink getHref={() => getConsumerUrl('/#download')} className="text-white/70 hover:text-white transition-colors">
                  Download de App
                </DynamicLink>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="font-semibold text-lg mb-4">Contact</p>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-white/70">
                <Mail size={18} />
                <span>info@valbewust.nl</span>
              </li>
              <li className="flex items-start gap-3 text-white/70">
                <MapPin size={18} className="mt-1" />
                <span>Kornalijnstoep 34<br />9403 RX Assen</span>
              </li>
              <li className="flex items-center gap-3">
                <Linkedin size={18} className="text-white/70" />
                <a
                  href="https://www.linkedin.com/company/valbewust"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-white transition-colors"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
            <Link href="/contact" className="inline-block mt-4 btn-cta text-sm py-2 px-4">
              Neem Contact Op
            </Link>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">
            &copy; {new Date().getFullYear()} ValBewust i.o. Alle rechten voorbehouden.
          </p>
          <div className="flex gap-6 text-sm">
            <Link href="/professionals/privacy" className="text-white/50 hover:text-white transition-colors">
              Privacybeleid
            </Link>
            <Link href="/professionals/voorwaarden" className="text-white/50 hover:text-white transition-colors">
              Algemene voorwaarden
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
